import { NgForm } from "@angular/forms";
import { getRandomNumber } from "../../helpers/function";
import { IFormTemplate } from "../../interfaces/utils.interface";
import { DismissReason } from "../../helpers/enums";
import { AfterViewInit } from "@angular/core";
import { FormEventArgs } from "./form-utils";
import {
  Component,
  Input,
  ContentChild,
  Output,
  EventEmitter,
  Directive,
  ElementRef
} from "@angular/core";

@Directive({
  selector: "[acFocus]"
})
export class ActiveControlFocus {
  constructor(private _el?: ElementRef) { }

  focus() {
    if (!this._el) {
      return;
    }

    this._el.nativeElement.focus();
  }
}

@Component({
  selector: "form-template",
  templateUrl: "./form-template.component.html"
})
export class FormTemplateComponent implements IFormTemplate, AfterViewInit {
  private _busy = false;
  private _okAndNew = false;
  private _adding = true;
  // private _watchObject: any;
  // private _differ: any;

  switchLabel = `switch_${getRandomNumber(1, 1000)}`;

  @Input() formTitle = "Mantenimiento";
  @Input() icon = "fa fa-edit";
  @Input() showIconTitle = true;
  @Input() form: NgForm;
  @Input() showOkButton = true;
  @Input() okButtonLabel = "Guardar";
  @Input() okButtonIcon = "fa fa-floppy-o";
  @Input() okButtonColor = "btn-primary";
  @Input() closeButtonStyle = new Object();

  @Input()
  get okAndNew(): boolean {
    return this._okAndNew;
  }

  @Output() okAndNewChange = new EventEmitter<boolean>();

  set okAndNew(value: boolean) {
    this._okAndNew = value;
    this.okAndNewChange.emit(this._okAndNew);
  }

  @Input() showOkAndNew = true;
  @Input() okAndNewLabel = "Guardar y nuevo";
  @Input() showCancelButton = true;
  @Input() cancelButtonLabel = "Cancelar";
  @Input() cancelButtonIcon = "";
  @Input() cancelButtonColor = "btn-secondary";
  @Input() showHeader = true;
  @Input() showCloseButton = true;
  @Output() onActionChange = new EventEmitter();

  @Input()
  get busy(): boolean {
    return this._busy;
  }

  @Output() onBusyChange = new EventEmitter();

  set busy(value: boolean) {
    this._busy = value;
    this.onBusyChange.emit(this._busy);
  }

  @Input()
  get adding(): boolean {
    return this._adding;
  }

  @Output() addingChange = new EventEmitter();

  set adding(value: boolean) {
    this._adding = value;
    this.addingChange.emit(this._adding);
  }

  @Input() keyboard = true;
  @Input() okKeyCode = 115;
  @Input() cancelKeyCode = 27;

  @ContentChild(ActiveControlFocus)
  private _activeControlFocus: ActiveControlFocus;

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  get focusControl(): ActiveControlFocus {
    if (!this._activeControlFocus) {
      return new ActiveControlFocus();
    }

    return this._activeControlFocus;
  }

  ok() {
    this._emit(DismissReason.Ok, "click");
  }

  cancel() {
    this._emit(DismissReason.Cancel, "click");
  }

  private _emit(sender: DismissReason, event: string) {
    this.onActionChange.emit(new FormEventArgs(sender, event));
  }
}
